module.exports = __webpack_public_path__ + "img/14-04_Acting Ethically.4d38abe1.svg";